const CENTIMOS_POR_EURO = 100;
const PORCENTAJE_TOTAL = 100;
const DECIMALES_EUROS = 2;

const redondearEuros = (euros) => Number(euros.toFixed(DECIMALES_EUROS));

/**
 * Calcula el importeAplicado de una promoción EN EUROS, alineado con el backend
 * `helpers/promociones.ts::calcularImporteAplicado`.
 *
 * - Promo de cifra: la cifra está en céntimos → se devuelve en euros (cifra / 100).
 * - Promo de porcentaje: se aplica el porcentaje sobre la base (en céntimos) y se
 *   convierte el resultado a euros, conservando exactamente la misma semántica de
 *   unidades que `calculaImporteDescuentos` de ModalReserva (que opera el porcentaje
 *   sobre el precio en céntimos).
 *
 * @param {object} promocion              Promoción seleccionada.
 * @param {number} promocion.cifra        Descuento fijo en CÉNTIMOS (si es promo de cifra).
 * @param {number} promocion.porcentaje   Porcentaje de descuento (si es promo de porcentaje).
 * @param {number} baseCentimos           Base sobre la que aplicar el porcentaje, en CÉNTIMOS.
 * @returns {number} importeAplicado en EUROS.
 */
export const calcularImporteAplicadoEuros = (promocion, baseCentimos = 0) => {
    if (promocion.cifra) {
        return parseFloat(promocion.cifra) / CENTIMOS_POR_EURO;
    }

    if (promocion.porcentaje) {
        const descuentoCentimos = baseCentimos * (Number(promocion.porcentaje) / PORCENTAJE_TOTAL);
        return redondearEuros(descuentoCentimos / CENTIMOS_POR_EURO);
    }

    return 0;
};
